import { AnalyticAction } from '@application/analytic/analytic.service';
import { withTranslation } from '@modules/i18n_and_l10n/with_translation';
import { LicenceHolderService } from '@services/licence_holder.service';
import { useService } from '@visiba/instantiation';
import { Item } from '../_item.component';

interface Props {
	__TEMP__navigate?: (url: string) => void;
	trackEvent(event: AnalyticAction): void;
}

export function LinkHome({ trackEvent, __TEMP__navigate }: Props): JSX.Element {
	const licenceHolderService = useService(LicenceHolderService);

	function handleClick(): void {
		trackEvent('Clicked: Home-tab');
	}

	return (
		<Item
			to={`/${licenceHolderService.alias}`}
			icon='home'
			iconActive='home_filled'
			label={withTranslation('PW.Component.Header.Picker.Home.Label')}
			data-testid='header_link_home'
			__TEMP__navigate={__TEMP__navigate}
			onClick={handleClick}
		/>
	);
}
